import { useId, useState } from 'react'
import Image from 'next/image'
import cn from 'classnames'
import { cloudflareLoader } from '@mc/image-cloudflare'
import { TrackClick } from 'pages/certificates/tracking'
import type { CohortContent } from '../types'

export const CohortFeatures = ({
  features,
}: {
  features: CohortContent['features']
}) => {
  const headingId = useId()
  const [activeIndex, setActiveIndex] = useState(0)
  const activeImage = features.items[activeIndex]?.image

  return (
    <section aria-labelledby={headingId} className='container py-8'>
      <div className='lg:grid lg:grid-cols-2 lg:items-center lg:gap-7'>
        <div>
          <h2 id={headingId} className='c-d-1 m-0 text-balance'>
            {features.headline}
          </h2>
          <ul className='m-0 mt-7 flex list-none flex-col gap-7 p-0 lg:gap-6'>
            {features.items.map(({ title, description, image }, index) => {
              const isActive = index === activeIndex

              return (
                <li key={title}>
                  <TrackClick event='certificateLandingClick' action={title}>
                    <button
                      type='button'
                      aria-pressed={isActive}
                      className={cn(
                        'flex w-full cursor-pointer flex-col gap-2 border-0 bg-transparent p-0 text-left text-c-text-tint-3 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 lg:border-l-4 lg:border-solid lg:pl-5',
                        isActive
                          ? 'lg:border-c-brand-highlight'
                          : 'lg:border-transparent lg:opacity-60',
                      )}
                      onClick={() => setActiveIndex(index)}
                    >
                      <span className='c-heading-3'>{title}</span>
                      <span className='c-body'>{description}</span>
                    </button>
                  </TrackClick>
                  <div className='relative mt-5 aspect-square overflow-hidden rounded-xl lg:hidden'>
                    <Image
                      src={image.url}
                      alt={image.alt}
                      fill
                      loader={cloudflareLoader}
                      sizes='100vw'
                      className='object-cover'
                    />
                  </div>
                </li>
              )
            })}
          </ul>
        </div>

        {activeImage && (
          <div className='relative hidden aspect-square overflow-hidden rounded-xl lg:block'>
            <Image
              key={activeImage.url}
              src={activeImage.url}
              alt={activeImage.alt}
              fill
              loader={cloudflareLoader}
              sizes='50vw'
              className='object-cover'
            />
          </div>
        )}
      </div>
    </section>
  )
}
